import React from 'react';

import { Outlet } from 'react-router';

import { ResourcesLayout } from 'src/layouts';

export const ResourcesOutlet: React.FC = () => {
  return (
    <ResourcesLayout>
      <Outlet />
    </ResourcesLayout>
  );
};
